import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-wrapper',
  templateUrl: './wrapper.component.html',
})
export class WrapperComponent {}
